import one from '@mailobj-browser/front/js/selectors/one.js'
import { load } from '../iframe.js'

export default async rte => {
  const { document } = globalThis

  return load(one(`#${rte}`, document))
}
